<template>
  <div>
    <app-header :main-logo="true" />
    <!-- S : Mypack visual-->
    <home-hero @click-composition="onClickComposition" />
    <!-- E : Mypack visual-->

    <!-- S : main -->
    <main class="a-service-main">
      <!-- S : 컨텐츠 영역 -->
      <div
        id="main_content"
        class="a-service-container"
      >
        <home-recommend-wrap
          @selected="onRecommendationSelected"
        />

        <home-main-btn-group
          @on-click-recombination="onClickRecombination"
          @on-click-apply="onClickApply"
        />
        <floating-button-group
          v-show="computedFloatingBtn"
          title-left="조합수정"
          title-right="바로신청"
          @click-left="onClickRecombination"
          @click-right="onClickApply"
        />
      </div>
      <!-- S : 20250306 ASB-12533 myPack 홈페이지 하단 제품 정보 추가 -->
      <div class="product-info-wrap">
          <ul class="product-info-cont list-type1">
              <li><b>식품의 유형 :</b> 건강기능식품</li>
              <li>
                  <b>제조업소명 :</b> 액세스 비즈니스 그룹 엘엘씨, 미국
                  <div class="product-info-detail">
                      <span><b>*밸런스 위드인 이뮤니티 :</b> 파이토지노믹스㈜, ㈜락토메이슨</span>
                      <span><b>*루바블렌드 :</b> 파이토지노믹스㈜</span>
                  </div>
              </li>
              <li><b>수입판매업소명/유통전문판매업소명 :</b> 한국암웨이㈜ 서울 강남구 영동대로 517</li>
              <li><b>포장비 :</b> 30포 당 1,500원 / <b>배송비(배송 주문 시) :</b> 6만원 이하 주문 시 3,300원</li>
          </ul>
      </div>
      <!-- E : 20250306 ASB-12533 myPack 홈페이지 하단 제품 정보 추가 -->
      <!-- E : 컨텐츠 영역 -->
      <notice-popup v-show="existNoticeList"
        :noticeList="noticeList"
        :isActive="isActive"
        @change-actice="closePopup"/>
    </main>
    <!-- E : main -->
    <modal-alert
      ref="refModalAlert"
    />

    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import HomeHero from '@/views/home/hero/HomeHero.vue';
import NoticePopup from '@/views/home/main/NoticePopup.vue';
import { log } from '@/utils/common';
import { mapGetters } from 'vuex';
import compositionHelpers from '@/utils/helpers/composition';
import { CONTEXT_TYPE } from '@/utils/constants';
import FloatingButtonGroup from '@/components/FloatingButtonGroup.vue';
import ModalAlert from '@/components/global/ModalAlert.vue';
import HomeRecommendWrap from './partial/HomeRecommendWrap.vue';
import HomeMainBtnGroup from './partial/HomeMainBtnGroup.vue';

function grabScrollEvent() {
  if (window.pageYOffset > 250) {
    this.topButtonOpacity = true;
  } else {
    this.topButtonOpacity = false;
  }
}

export default {
  name: 'Home',
  components: {
    AppHeader,
    AppFooter,
    NoticePopup,
    HomeHero,
    HomeRecommendWrap,
    HomeMainBtnGroup,
    FloatingButtonGroup,
    ModalAlert,
  },
  data() {
    return {
      selectedPackCd: null,
      showModal: false,
      topButtonOpacity: false,
      bindedHandler: null,
      existNoticeList: false,
    };
  },
  computed: {
    ...mapGetters({
      recommendationPacks: 'recommendation/recommendations',
    }),
    computedFloatingBtn() {
      return this.topButtonOpacity;
    },
    noticeList() {
      return this.$store.getters["notice/noticeList"];
    },
    isActive: {
      get () {
        if (document.cookie.indexOf('noticeToday=close') > -1) {
          this.existNoticeList = false;
          return this.$store.getters["notice/isActive"];
        } else {
          this.existNoticeList = this.$store.getters["notice/isActive"];
          return this.$store.getters["notice/isActive"];
        }
      },
      set (newValue) {
        this.existNoticeList = newValue;
      }
    }

  },
  created() {
    if (process.env.NODE_ENV === 'development') {
      window.dev = {
        openTestModal: this.openTestModal,
        closeTestModal: this.closeTestModal,
      };
    }
    this.bindedHandler = grabScrollEvent.bind(this);
    window.addEventListener('scroll', this.bindedHandler);

    this.$store.dispatch('agreement/init');
    this.$store.dispatch('payment/reset');
    // this.$store.dispatch("ssoToken");
    // this.$store.dispatch('context/unset');
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.bindedHandler);
  },
  mounted() {
    // log("Home::Mounted", "스토어 주문 정보 초기화");
    // this.$store.dispatch('resetOrderInfo');
  },
  methods: {
    closePopup (){
        this.isActive = false;
    },
    onDisposeModal() {
      log('Home::onDisposeMidal', 'modal closed with dispose event');
    },
    onRecommendationSelected(packCd) {
      this.selectedPackCd = packCd;
    },
    async onClickComposition() {
      // 주문서 생성 제한 해제
      // if (!await compositionHelpers.checkMypackLimit(this.$refs.refModalAlert)) {
      //   return;
      // }
      const ctx = compositionHelpers.createEmptyContext();
      compositionHelpers.updateContext(this.$store, ctx);

      this.$router.push(`/agreement/${CONTEXT_TYPE.COMPOSITION}`);
    },
    async onClickRecombination() {
      log('HomeMainBtnGroup::onClickRecombination', `recombination with ${this.selectedPackCd}`);

      if (this.selectedPackCd === null) {
        await this.$refs.refModalAlert.openWithMessage('조합을 수정하실 추천팩을 선택해주세요.');
        return;
      }
      // 주문서 생성 제한 해제
      // if (!await compositionHelpers.checkMypackLimit(this.$refs.refModalAlert)) {
      //   return;
      // }

      compositionHelpers.doRecompositionFromRecommendationPack(
        this.$store,
        this.recommendationPacks,
        this.selectedPackCd,
      );
      this.$router.push(`/agreement/${CONTEXT_TYPE.RECOMPOSITION}`);
    },
    async onClickApply() {
      log('HomeMainBtnGroup::onClickApply', `apply with ${this.selectedPackCd}`);

      if (this.selectedPackCd === null) {
        await this.$refs.refModalAlert.openWithMessage('추천팩을 선택해 주세요.');
        return;
      }
      // 주문서 생성 제한 해제
      // if (!await compositionHelpers.checkMypackLimit(this.$refs.refModalAlert)) {
      //   return;
      // }

      /**
       * finalProducts: [
       *  {
       *    days: number,
       *    item_name: string,
       *    item_sku: string,
       *    pockets: number,
       *    seq: string,
       *   },
       *
       * ]
       */
        compositionHelpers.doCompositionFinalFromRecommendationPack(
        this.$store,
        this.recommendationPacks,
        this.selectedPackCd,
      );
      this.$router.push(`/agreement/${CONTEXT_TYPE.COMPOSITION_FINAL}`);
    },
  },
};
</script>
